import { Controller } from "@hotwired/stimulus"

// Dismissable controller for banners/alerts
// Stores dismissal state in localStorage to prevent re-showing
export default class extends Controller {
    static values = { key: String }

    connect() {
        // Check if already dismissed today
        if (this.isDismissed()) {
            this.element.remove()
        }
    }

    dismiss() {
        // Store dismissal with timestamp
        localStorage.setItem(this.storageKey, Date.now().toString())

        // Animate out
        this.element.style.transition = 'opacity 0.3s, transform 0.3s'
        this.element.style.opacity = '0'
        this.element.style.transform = 'translateY(-10px)'

        setTimeout(() => {
            this.element.remove()
        }, 300)
    }

    isDismissed() {
        const dismissed = localStorage.getItem(this.storageKey)
        if (!dismissed) return false

        // Check if enough time has passed (24 hours)
        const dismissedAt = parseInt(dismissed, 10)
        const hoursSince = (Date.now() - dismissedAt) / (1000 * 60 * 60)
        return hoursSince < 24
    }

    get storageKey() {
        return `dismissed_${this.keyValue}`
    }
}
